import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {
  gsap.registerPlugin(ScrollTrigger)
}

const documentReady = () => {

  const scrollMeteor = () => {
    let $meteor = $('.meteor')
    let $meteorLine = $( '.is-line', $meteor );

    $meteor.each( (i, obj) => {
      gsap.fromTo( obj, {
        opacity: 0,
        y: mq.matches ? -40 : -80,
      },{
        opacity: 1,
        y: 0,
        scrollTrigger: {
          trigger: obj,
          duration: .5,
          start: 'top center',
        }
      });
    });

    $meteorLine.each( (i, obj) => {
      gsap.fromTo( obj, {
        height: 0,
      },{
        height: mq.matches ? 84 : 110,
        scrollTrigger: {
          trigger: obj,
          duration: 1.5,
          start: 'top center',
        }
      });
    });
  }
  w.load['loadHtml'].then( scrollMeteor )
}

export default function METEOR () {
  init()
  $( documentReady )
}